import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export function useMetricateHit(counterId: number): void {
    const location = useLocation();

    useEffect(() => {
        const language = process.env.REACT_APP_LANG || 'ru';

        if (language !== 'ru') {
            const metrikaScripts = document.querySelectorAll('script[data-metrika="yandex"]');
            const metrikaNoscripts = document.querySelectorAll('noscript[data-metrika="yandex"]');

            metrikaScripts.forEach(el => el.remove());
            metrikaNoscripts.forEach(el => el.remove());

            if (window.ym) {
                delete window.ym;
            }
            return;
        }

        if (process.env.NODE_ENV !== 'production') return;
        if (typeof window.ym !== 'function') return;

        window.ym(
            counterId,
            'hit',
            `${location.pathname}${location.search}`,
            {
                title: document.title,
                referer: document.referrer || sessionStorage.getItem('prevPath') || undefined,
            },
        );

        sessionStorage.setItem('prevPath', location.pathname);
    }, [location, counterId]);
}